import React, { useContext, useState, useEffect, useRef } from 'react';
import { AppContext } from '../App';
import { getInlineLoader } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';
import { AiOutlineInstagram, AiOutlineWhatsApp } from 'react-icons/ai';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import MobileInterface from '../MobileInterface';


export default function View(props) {
  const appContext = useContext(AppContext);
  const [ ready, setReady ] = useState(false);

  const init = async () => {

    setReady(true);
    
  }

  useEffect(() => {
    init();
  }, []);

  const openWhatsapp = () => {
    //open whatsapp (native) provide number
    MobileInterface.openLink('https://wa.me/+255758779913');
  }

  const openInstagram = () => {
    //open instagram (native) provide link
    MobileInterface.openLink('https://instagram.com/soldrax_app');
  }

  const ratePlaystore = () => {
    MobileInterface.rateApp();
  }

  const shareApp = () => {
    //trigger app sharing (native) provide playstore link
    MobileInterface.shareApp();
  }



  if(ready) {
    return (
      <>
        <div 
          style={{
            width: "100%",
            margin: "0px",
            padding: "0",
            overflow: "hidden",
            marginTop: "20px"
          }}
          className='bg-goldish'
        >
          <div
            className='d-flex bg-black'
          >
            <img
              src={chess_pieces}
              style={{
                width: "50%",
                height: "auto",
                margin: "0",
                flexShrink: "0",
              }}
            />

            <img
              src={cards_row}
              style={{
                width: "50%",
                height: "auto",
                margin: "0",
                flexShrink: "0",
              }}
            />
          </div>

          <div 
            className='text-start'
            style={{
              width: "100%",
              padding: "10px"
            }}
          >
            <h6
              style={{
                fontSize: "46px"
              }}
              className='font-light'
            >
              New Soldrax Is Here!
            </h6>

            <h6
              style={{
                fontSize: "20px"
              }}
              className=''
            >
              Furahia michezo mbalimbali ya Karata na Drafti
            </h6>
          </div>

          <div 
            className='text-end'
            style={{
              width: "100%",
              padding: "10px"
            }}
          >
            <button
              className='btn btn-rounded bg-dark'
              onClick={shareApp}
            >
              Share Now!
            </button>
          </div>

        </div>

        <div className="row" style={{ marginTop: "20px" }}>
          
          <div onClick={openWhatsapp} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
            <AiOutlineWhatsApp color="#209e30" size={60}/>
            <small className="form-text">Contact Us</small>
          </div>

          <div onClick={openInstagram} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
            <AiOutlineInstagram color="#c72248" size={60}/>
            <small className="form-text">Follow Us</small>
          </div>

          <div onClick={ratePlaystore} className="col-md-3 col-4 text-center" style={{ marginBottom: "20px", cursor: "pointer" }}>
            <IoLogoGooglePlaystore size={60}/>
            <small className="form-text">Rate Us</small>
          </div>

        </div>
      </>
    ) 
  } else {
    return (
      <div style={{ width: "100%" }} className='mSupportLoading'>
        {getInlineLoader()}
      </div>
    ) 
  }

  
}
